<div class="modal-header">
  <div class="modal-title">
    <h3 class="mb-0">{{ title }}</h3>
    <p class="modal-subtitle mb-0">
      VIVE encourages the use of only approved vendors.
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <div class="row mb-3">
    <div class="col-md-6">
      <div class="form-group mb-0">
        <label class="form-label" for="qsb-trade-filter">Trade</label>
        <app-trade-selection-dropdown
          (tradeSelectionEvent)="handleTradeSelection($event)"
        ></app-trade-selection-dropdown>
      </div>
    </div>
  </div>

  <div class="vendor-grid">
    <app-company-vendors-grid
      [FilterModel]="FilterModel"
      [gridPrimaryKeyFieldName]="'VendorId'"
      [overrideAdditionalQueryData]="overrideAdditionalQueryData"
      [gridName]="'ProposalRequest'"
      [selectedRowsPrimaryKeys]="selectedProposalRequestVendorIds"
      [rowSelectionType]="'multiple'"
      [suppliedQueryData]="suppliedQueryData"
      [suppressFieldDotNotation]="false"
      [(resetFilterModel)]="clearGridFilters"
      (rowSelectionChanged)="vendorSelection($event)"
    ></app-company-vendors-grid>
  </div>
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="cancel()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="continue()">
      Continue
    </button>
  </div>
</div>
